<template>
      <canvas class="xyr" ref="canvas" :width="WIDTH" :height="HEIGHT">
        <!-- <audio ref="audio" :src="audioUrl" preload @canplaythrough="dd"/> -->
      </canvas>
</template>

<script>
import { loadImg,qver } from "@/d";
import { CONFS } from "./animateconf";
const WIDTH = 200;
const HEIGHT = 210;

for (let animateKey in CONFS) {
  let conf = CONFS[animateKey];
  if (!conf.audio) {
    continue;
  }
  let audio = document.createElement("audio");
  audio.preload = true;
  audio.src = `res/aniAndAud/${conf.audio}.mp3`+qver;
  audio.load();
  conf.audio = audio;
}

document.addEventListener("WeixinJSBridgeReady", WeixinJSBridgeReady, false);
function WeixinJSBridgeReady() {
  const mytime = 50;
  // function play(audio) {
  //     audio.play().catch(()=>{
  //       // alert("bbbbbbbbb");
  //       audio.oncanplaythrough = ()=>{
  //         play(audio);
  //       };
  //     });
  //     setTimeout(() => {
  //       audio.pause();
  //     }, mytime);
  //   }
  for (let animateKey in CONFS) {
    let audio = CONFS[animateKey].audio;
    if (!audio) continue;
    audio.play().catch(() => {
      // alert("bbbbbbbbb");
      audio.oncanplaythrough = () => {
        // play(audio);
      };
    });
    setTimeout(() => {
      audio.pause();
    }, mytime);
  }

  setTimeout(() => {
    document._WeixinJSBridgeReady = true;
    document.dispatchEvent(new Event("_WeixinJSBridgeReady"));
  }, mytime);
}

let currentAudio;

export default {
  data() {
    return {
      WIDTH,
      HEIGHT,
      imgs: []
      // showCanvas:true,
    };
  },

  props: {
    animateKey: String
    // showCanvas:Boolean,
  },

  computed: {},

  updated() {
    // window.console.log(this.animateKey+"-aaaaaaa----------永远执行不到-------------------")
  },

  mounted() {
    // this._that = this;
    document.addEventListener("visibilitychange", this.visibilitychange);
    let animateKey = this.animateKey;

    // window.console.log(animateKey+"---d---------------------------")

    let conf = CONFS[animateKey];

    if (conf.width) this.WIDTH = conf.width;
    if (conf.height) this.HEIGHT = conf.height;

    let noAnimation = conf.totalFrames == undefined || conf.totalFrames == 0;

    if (noAnimation) {
      this._next();
    } else {
      let pagesize = conf.pagesize ? conf.pagesize : 50;
      let n = Math.ceil(conf.totalFrames / pagesize);
      for (let i = 0; i < n; i++) {
        loadImg(`res/aniAndAud/${animateKey}/${i + 1}.png`+qver, img => {
          this.imgs[i] = { img };
          this._next();
        });
      }
    }

    if (!document._WeixinJSBridgeReady) {
      document.addEventListener("_WeixinJSBridgeReady", this._next, false);
    }

    this.$root.$on("pause_animate_audio", this.pause_animate_audio);
  },
  beforeDestroy() {
    // clearInterval(this.tickId);
    cancelAnimationFrame(this.tickId);
    delete this.tickId;
    document.removeEventListener("visibilitychange", this.visibilitychange);
    this.$root.$off("pause_animate_audio", this.pause_animate_audio);
  },

  methods: {
    visibilitychange() {
      let audio = currentAudio;
      if (!audio) return;
      if (document.hidden) {
        this._t = audio.currentTime;
        audio.pause();
      } else {
        setTimeout(() => {
          audio.play(this._t);
        }, 100);
      }
    },
    pause_animate_audio() {
      if (!currentAudio) return;
      currentAudio.removeEventListener("play", this.startAnimation, {
        once: true
      });
      currentAudio.pause();
      currentAudio = null;
    },
    play() {
      let animateKey = this.animateKey;
      let conf = CONFS[animateKey];

      let pagesize = conf.pagesize ? conf.pagesize : 50;

      let WIDTH = this.WIDTH;
      let HEIGHT = this.HEIGHT;
      // ddddddddddddddddddddddddddddddddddddddddddddddddd
      this.pause_animate_audio();
      currentAudio = CONFS[animateKey].audio;

      // window.console.log("bbbbbbbbbbbbbbcccccccccccccccccccccccc");

      let that = this;
      let canvas = this.$refs.canvas; //window.document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      let ani_frames = 0;
      function nextFrame() {
        // 更新一帧
        let mod = ani_frames % conf.totalFrames;
        let img = that.imgs[~~(mod / pagesize)].img;
        let index = mod % pagesize;
        canvas.width = WIDTH; // 清空动画
        ctx.drawImage(
          img,
          (index % 10) * WIDTH,
          ~~(index / 10) * HEIGHT,
          WIDTH,
          HEIGHT,
          0,
          0,
          WIDTH,
          HEIGHT
        );
        // window.console.log(ani_frames, animateKey);
        ani_frames++;
        // ani_frames = ani_frames % conf.totalFrames;
        // window.console.log(ani_frames);
        if (0 == ani_frames % conf.totalFrames) {
          // window.console.log("gggggg", this);
          that.$emit("loop");
          if (!conf.loop) {
            return true;
          }
        }
      } // end tick
      // alert("cc");
      function startAnimation() {
        let startMs = Date.now();
        function tick() {
          let t = Date.now() - startMs;
          let ideaFrame = t / (conf.duration * 1000) * conf.totalFrames;
          // let t2 = conf.duration / conf.totalFrames * 1000 * ani_frames;
          if (ideaFrame >= ani_frames) {
            if (!nextFrame()) {
              requestTick();
            }
          } else {
            requestTick();
          }
        }

        function requestTick() {
          that.tickId = requestAnimationFrame(tick);
        }

        requestTick(); // 发动第一帧
      }
      that.startAnimation = startAnimation;

      if (currentAudio) {
        // currentAudio.addEventListener("play",startAnimation, {once:true});
        // currentAudio.pause();
        currentAudio.addEventListener("play", that.startAnimation, {
          once: true
        });
        // currentAudio.onplaying = ()=>{window.console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbb"+Date.now())}
        currentAudio.play();
        // startAnimation();
      } else {
        startAnimation();
      }
    },
    _next() {
      // if (!this._canPlayThrough) return;
      if (!document._WeixinJSBridgeReady) return;

      let animateKey = this.animateKey;
      let conf = CONFS[animateKey];
      let pagesize = conf.pagesize ? conf.pagesize : 50;

      let n = Math.ceil(conf.totalFrames / pagesize);
      // window.console.log(animateKey, "bbbbbbbbbb", n, 0 < n);
      for (let i = 0; i < n; i++) {
        if (!this.imgs[i]) return;
      }
      // window.console.log(animateKey, "bbbbbbbbbb");
      let autoplay = conf.autoplay == false ? false : true;
      if (autoplay) {
        let canvas = this.$refs.canvas;
        if (!canvas) return;
        this.play();
      }

      this.$emit("init", this);
    }
    // canPlayThrough(e) {
    //   alert("d");
    //   this.audio = e.target;
    //   this._canPlayThrough = true;
    //   this._next();
    // }
  },
  components: {}
};
</script>

<style lang="scss">
</style>
